export default "__VITE_ASSET__ChzMZeL___"